@if(visible()){
<div class="jk-combobox-border">
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  <!-- <mat-select [(ngModel)]="value" [title]="label()" [panelWidth]="width" (valueChange)="onValueChange">
        @for (idNameItem of items; track idNameItem) {
        <mat-option [value]="idNameItem.id"> {{idNameItem.id}}| {{idNameItem.name}}</mat-option>
        }
      </mat-select> -->
  <!-- class="mt-4 flex items-center" -->
  <div>
    <!-- <select [(ngModel)]="value"
      (ngModelChange)="onValueChange($event)">
      <option value="">請選擇</option>
      @for (idNameItem of items; track idNameItem) {
      <option [value]="idNameItem.id">{{idNameItem.name}}</option>
      }
    </select> -->
    <mat-select [(ngModel)]="value" class="w-full" (valueChange)="onValueChange($event)"
      [matTooltip]="value.toString()">
      @if(canSpace()){
      <mat-option value="">[空白]</mat-option> <!-- 空白選項 -->
      }
      @for(idNameItem of items(); track idNameItem) {
      <mat-option [value]="idNameItem.id">{{idNameItem.name}}</mat-option>
      }
    </mat-select>
  </div>


  <!-- @if (animalControl.hasError('required')) {
        <mat-error>Please choose an animal</mat-error>
      }
      <mat-hint>{{animalControl.value?.sound}}</mat-hint> -->
  <!-- </mat-form-field> -->
</div>
}
<!-- <mat-select [(value)]="value" [title]="label()" [panelWidth]="width">
  (valueChange)="onValueChange($event)"
  @for (idNameItem of items; track idNameItem) {
    <mat-option [value]="idNameItem.id">{{idNameItem.id}}|{{idNameItem.name}}</mat-option>
  }
</mat-select> -->